window.config = {
    debug: true,
    apiEndpoint: 'https://api.stage.zcooly.se',
    loginSiteSV: 'https://login.stage.zcooly.se',
    loginSiteEN: 'https://login.stage.zcooly.com',
};
